<template>
  <!-- Withdrawing consent must be as easy as giving it, so this sits wherever
       the cookie policy is linked. -->
  <a href="#" role="button" @click.prevent="open">
    <slot>{{ $t('cookie_consent_settings') }}</slot>
  </a>
</template>

<script>
  export default {
    name: 'CookieSettingsLink',
    methods: {
      open () {
        this.$bus.emit('open-cookie-preferences')
      },
    },
  }
</script>
